module.exports = __webpack_public_path__ + "assets/img/ArtyWilmotte_003.8246e089-ps.jpg";